



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// CHECKCUSTOMEREXISTFOREMAILREGISTER
// CHECKCUSTOMEREXISTFOREMAILREGISTER
const CHECKCUSTOMEREXISTFOREMAILREGISTER= createAsyncThunk(
  "checkCustomerExistForEmailRegister/checkCustomerExistForEmailRegister",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const checkCustomerExistForEmailRegisterSlice = createSlice({
  name: "checkCustomerExistForEmailRegisterSlice",
  initialState: {
    checkCustomerExistForEmailRegister: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcheckCustomerExistForEmailRegister: (state) => {
        state.checkCustomerExistForEmailRegister.loading = false
        state.checkCustomerExistForEmailRegister.error = false
        state.checkCustomerExistForEmailRegister.data = []
        state.checkCustomerExistForEmailRegister.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CHECKCUSTOMEREXISTFOREMAILREGISTER.fulfilled, (state, action) => {
      state.checkCustomerExistForEmailRegister = {
        ...state.checkCustomerExistForEmailRegister,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CHECKCUSTOMEREXISTFOREMAILREGISTER.pending, (state, action) => {
      state.checkCustomerExistForEmailRegister = {
        ...state.checkCustomerExistForEmailRegister,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CHECKCUSTOMEREXISTFOREMAILREGISTER.rejected, (state, action) => {
      state.checkCustomerExistForEmailRegister = {
        ...state.checkCustomerExistForEmailRegister,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const checkCustomerExistForEmailRegisterAction = {
    CHECKCUSTOMEREXISTFOREMAILREGISTER,
};

export { checkCustomerExistForEmailRegisterAction };
export default checkCustomerExistForEmailRegisterSlice.reducer;
export const {setInitialStateOfcheckCustomerExistForEmailRegister} = checkCustomerExistForEmailRegisterSlice.actions